import { createContext, useState, useEffect } from "react";
import { getEbayAccessTokenFromCookie } from "../lib/authentication";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [sellingLimit, setSellingLimit] = useState(0);
  const [inventory, setInventory] = useState({});
  const [store, setStore] = useState({});

  let ebayAccessToken = "";

  const checkAuth = async () => {
    console.log("abc1 starting check auth");
    if (!ebayAccessToken || ebayAccessToken === "undefined") {
      ebayAccessToken = getEbayAccessTokenFromCookie();
      console.log("abc1 ebay access token from cookie: ", ebayAccessToken);
    }
    
    if (!ebayAccessToken || ebayAccessToken === "undefined") {
      console.log("No code found in url, Redirecting to login page.");
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
      return;
    }

    console.log("Cookie found. Trying to login.");
    // get /api/user POST wth the ebay access token in the body
    fetch(`${process.env.REACT_APP_API_URL}/user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ebayAccessToken }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("USER DATA FROM EBAY");
        if (data.store) {
          setLoggedIn(true);
          setSellingLimit(data?.item?.sellingLimit?.quantity);
          setInventory(data?.inventory);
          setStore(data?.store);
          console.log(data);
          return data;
        }
      })
      .catch((error) => console.error(error));
  };

  // get code from url
  useEffect(() => {
    console.log("running useEffect in UserProvider");
    if (!loggedIn) {
      checkAuth();
    }
  }, []);

  const value = {
    // auth
    loggedIn,
    ebayAccessToken,
    checkAuth,
    store,
    sellingLimit,
    inventory,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
